// removed by extract-text-webpack-plugin
module.exports = {"header":"UpgradeEffectContent_header--lJ_12","title":"UpgradeEffectContent_title--3SRUx","base":"UpgradeEffectContent_base--1q0tY","tableTitle":"UpgradeEffectContent_tableTitle--37t6R","titleText":"UpgradeEffectContent_titleText--qaA5a","description":"UpgradeEffectContent_description--SDNlY","content":"UpgradeEffectContent_content--2arC-","bonusHolder":"UpgradeEffectContent_bonusHolder--1Kpp0","warning":"UpgradeEffectContent_warning--zFu4-","nextLevel":"UpgradeEffectContent_nextLevel--Hihpg"};


//////////////////
// WEBPACK FOOTER
// ./containers/CommandCenterCard/components/UpgradeEffectContent/UpgradeEffectContent.scss
// module id = 2145
// module chunks = 11